import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsFormDetails from "./en-us/form-details.json";
import localizationEnUsTableAssignments from "./en-us/table-assignments.json";

export const localizationEnUsSubscription = {
  ...localizationEnUsHeader,
  ...localizationEnUsFormDetails,
  ...localizationEnUsTableAssignments,
};
